import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchDailyBrief } from "../services/aiBriefService";

/** Full-text version of the AI daily brief. Shareable / SEO-friendly URL. */
export default function DailyBriefPage() {
  const [brief, setBrief] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchDailyBrief().then((data) => {
      if (cancelled) return;
      setBrief(data);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="max-w-[760px]">
      <Link
        to="/"
        className="mb-3 inline-block font-head text-[12.5px] font-semibold text-sub hover:text-brand"
      >
        ← Kryefaqja
      </Link>

      <header className="mb-6 border-b-2 border-ink pb-4">
        <div className="mb-2 flex items-center gap-2">
          <span className="grid h-[26px] w-[26px] place-items-center rounded-md bg-ai text-[14px] font-bold text-white">
            ✦
          </span>
          <span className="font-head text-[11px] font-bold uppercase tracking-wider text-ai">
            Përmbledhje nga AI
          </span>
        </div>
        <h1 className="font-head text-[32px] font-bold leading-tight tracking-tight text-ink md:text-[40px]">
          Përmbledhja e ditës
        </h1>
        <p className="mt-2 text-[13px] text-sub">
          Sintetizuar automatikisht nga inteligjenca artificiale, bazuar në
          klasterët kryesorë të lajmeve të 24 orëve të fundit
          {brief?.generatedAtFull && ` · përditësuar ${brief.generatedAtFull}`}
          .
        </p>
      </header>

      {loading ? (
        <p className="text-[14px] text-sub">Po ngarkohet përmbledhja…</p>
      ) : (
        <>
          {/* Bullets card */}
          <section className="rounded-card bg-ai-bg p-6">
            <h2 className="mb-3 font-head text-[12px] font-bold uppercase tracking-wider text-ai">
              Pikat kryesore
            </h2>
            <ul>
              {brief.bullets.map((b, i) => (
                <li
                  key={i}
                  className="flex gap-3 border-t border-black/10 py-3 text-[14.5px] leading-relaxed text-ink first:border-t-0"
                >
                  <span className="font-bold text-ai">›</span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Prose */}
          {brief.prose && (
            <section className="mt-8">
              <h2 className="mb-3 font-head text-[12px] font-bold uppercase tracking-wider text-sub">
                Pamja e plotë
              </h2>
              <div className="flex flex-col gap-4">
                {brief.prose
                  .split(/\n{2,}/)
                  .filter((p) => p.trim())
                  .map((p, i) => (
                    <p
                      key={i}
                      className="text-[15px] leading-relaxed text-ink"
                    >
                      {p.trim()}
                    </p>
                  ))}
              </div>
            </section>
          )}

          <footer className="mt-10 border-t border-line pt-4 text-[12px] text-sub">
            Përmbledhja gjenerohet rishtaz vetëm kur grupi i klasterëve
            kryesorë ndryshon. Nëse keni dyshime për saktësinë, klikoni mbi
            artikujt origjinalë në kryefaqe.
          </footer>
        </>
      )}
    </div>
  );
}
